import _ from "lodash";
import Joi from "joi";
import Decimal from "decimal.js";

export type InputErrors = {
  [field: string]: string;
};

export class InputValidationError extends Error {
  constructor(public fields: InputErrors) {
    super(JSON.stringify(fields));
  }
}

export type InputValidator<T> = (data: Partial<T>) => T;

const getErrorMessage = (type: string) =>
  ((
    {
      "any.required": "To pole jest wymagane.",
      "object.base": "To pole jest wymagane.",
      "date.base": "Wartość musi być poprawną datą.",
      "number.positive": "Wartość musi być dodatnią liczbą.",
    } as any
  )[type] || type);

export const joiValidator =
  <T>(joiSchema: Joi.SchemaMap<T>): InputValidator<T> =>
  (data) => {
    try {
      return Joi.attempt(
        data,
        Joi.object(joiSchema)
          .options({ presence: "required", abortEarly: false })
          .unknown(true),
      );
    } catch (e) {
      if (e instanceof Joi.ValidationError) {
        const fieldErrors = _.mapValues(
          _.groupBy(e.details, (errorDetail) => errorDetail.path),
          (e) => getErrorMessage(e[0].type || e[0].message),
        );

        throw new InputValidationError(fieldErrors);
      }
      throw e;
    }
  };

export const joiItemRef = Joi.object({
  id: Joi.number().integer().required(),
}).unknown(true);

export const joiActiveRevisionRef = Joi.object({
  activeId: Joi.number().integer().required(),
}).unknown(true);

export const joiDecimal = Joi.custom((value, helpers) => {
  if (typeof value === "object" && value instanceof Decimal) return value;
  else
    try {
      return new Decimal(value);
    } catch (err) {
      throw new Error("Couldn't parse decimal");
    }
});

export const canAddToUniqueList =
  <T>(isEqual: (a: T, b: T) => boolean) =>
  (list: T[], item: T) =>
    list.filter((x) => isEqual(x, item)).length === 0;
